/* eslint-disable @typescript-eslint/no-explicit-any */
import { IFinalResponse, XEventData, XStateMachine } from '../types';
import EventsHelper from '../config/events/EventsHelper';
import { IMachine } from './constants';
import { xstateInterpreter } from './handlersXstate';
import { validateVersion } from './version';

export const callServiceMachine = (
  machine: XStateMachine<any, any, any>,
  params?: XEventData,
  nameService?: string,
): Promise<IFinalResponse> =>
  new Promise((resolve) => {
    const resultCompare = validateVersion();
    if (resultCompare?.result < 0) {
      const msg = `Revisar versão: Core-Engine (${resultCompare?.versionData?.version}) < Core-Defs (${resultCompare?.versionData?.versionDefs})`;
      throw new Error(msg);
    }

    try {
      const machineService = xstateInterpreter(machine);

      machineService.start();
      machineService.send(IMachine.START, { ...params });

      machineService.onTransition((state) => {
        if (nameService !== undefined) {
          EventsHelper.emitMessage(nameService, state.value);
        }

        if (state.value === IMachine.FINISH) {
          let stopped = false;
          Object.values(state.context).forEach((ctxResponse: any) => {
            if (
              ctxResponse &&
              ctxResponse.errorCode &&
              ctxResponse.errorCode === '990'
            ) {
              resolve({
                entity: 'MachineContextExpection',
                data: null,
                errors: ctxResponse,
                success: false,
              });
              machineService.stop();
              stopped = true;
            }
          });
          if (!stopped) {
            resolve(state.context.finalResponse);
            machineService.stop();
          }
        }
      });
    } catch (error) {
      resolve({
        entity: 'MachineExpection',
        data: null,
        errors: error,
        success: false,
      });
    }
  });
